export function captureFrame(videoFile, time = 0) {
  return new Promise((resolve, reject) => {
    const vdo = document.createElement("video");
    vdo.currentTime = time;
    vdo.muted = true;
    vdo.autoplay = true;
    vdo.src = URL.createObjectURL(videoFile);
    vdo.oncanplay = async () => {
      const frame = await drawVideo(vdo);
      resolve(frame);
    };
    vdo.onerror = err => {
      console.log("video capture error", err);
      reject(err);
    }
  });
}

function drawVideo(vdo) {
  return new Promise((resolve, reject) => {
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    canvas.width = vdo.videoWidth;
    canvas.height = vdo.videoHeight;
    ctx.drawImage(vdo, 0, 0, canvas.width, canvas.height);
    canvas.toBlob(blob => {
      resolve({
        blob,
        url: URL.createObjectURL(blob)
      });
    });
  });
}



// WEBPACK FOOTER //
// ./src/components/ChunkUpload/captureFrame.js